"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
//import nestedComponentForm from '../_classes/nested/NestedComponent.form';
const Components_1 = __importDefault(require("../../Components"));
const chart_edit_display_1 = __importDefault(require("./editForm/chart.edit.display"));
const chart_edit_data_1 = __importDefault(require("./editForm/chart.edit.data"));
const AriForm_1 = require("../../../AriForm");
/**
 *
 * @param {...any} extend
 */
function default_1(...extend) {
    return Components_1.default.baseEditForm([
        {
            key: 'display',
            components: chart_edit_display_1.default
        },
        {
            key: 'data',
            components: chart_edit_data_1.default,
        },
        {
            key: 'validation',
            ignore: AriForm_1.AriForm.isBPM,
        },
        {
            key: 'api',
            components: AriForm_1.AriForm.isBPM
        },
        {
            key: 'logic',
            ignore: AriForm_1.AriForm.isBPM,
        },
        {
            key: 'layout',
            ignore: AriForm_1.AriForm.isBPM,
        },
        {
            key: 'addons',
            ignore: AriForm_1.AriForm.isBPM,
        },
        {
            key: 'conditional',
            ignore: AriForm_1.AriForm.isBPM,
        },
    ], ...extend);
}
exports.default = default_1;
